import { PaginationOffsetSearchSchema } from "@design-system/pagination/schemas";
import z from "zod/v4";

import { OperatorSchema } from "../../../enums/schemas/operator";
import { createOffsetListSchema } from "../../../shared/schemas/paginated-list";

const CompanyBaseSchema = z.object({
  id: z.number().int(),
  name: z.string().nullish(),
});

const CompanySchema = CompanyBaseSchema.extend({
  crmId: z.number().int().nullish(),
  type: z.string().nullish(),
  operatorId: OperatorSchema.shape.id.optional(),
});

const CompanyPageSchema = createOffsetListSchema(CompanySchema, "company");

const CompanyListSchema = CompanyPageSchema.transform((page) => page.data);

type Company = z.infer<typeof CompanySchema>;

const COMPANY_PAGE_SIZE = 100;

const CompaniesSearchSchema = PaginationOffsetSearchSchema.extend({
  limit: z
    .number()
    .int()
    .positive()
    .default(COMPANY_PAGE_SIZE)
    .transform(String),
  operatorId: OperatorSchema.shape.id
    .optional()
    .transform((value) => (value === undefined ? undefined : String(value))),
  search: z
    .string()
    .optional()
    .transform((value) => value?.trim() || undefined),
  include: CompanySchema.shape.id
    .optional()
    .transform((value) => (value && value > 0 ? String(value) : undefined)),
});

type CompaniesSearch = z.input<typeof CompaniesSearchSchema>;

export {
  COMPANY_PAGE_SIZE,
  CompaniesSearchSchema,
  CompanyBaseSchema,
  CompanyListSchema,
  CompanyPageSchema,
  CompanySchema,
};
export type { CompaniesSearch, Company };
